import { Button } from '@primer/react'
import React from 'react'

const Badger = () => {
  return <Button>Click me</Button>
}

export default Badger
